import { LegalLayout } from "./LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout
      eyebrow="Rechtliches"
      title={<>Datenschutz<em>­erklärung</em></>}
      updated="12. Mai 2026"
    >
      <p>
        Wir nehmen den Schutz Ihrer personenbezogenen Daten ernst. Die folgende
        Erklärung informiert über Art, Umfang und Zwecke der Erhebung und
        Verwendung personenbezogener Daten im Rahmen unseres Angebots
        Vitanara.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich im Sinne der Datenschutzgrundverordnung (DSGVO) ist:
      </p>
      <p>
        <strong>tino24/7 GmbH</strong>
        <br />
        Ringbahnstr. 42
        <br />
        12099 Berlin
        <br />
        Deutschland
        <br />
        Geschäftsführer: Kai Först
        <br />
        Handelsregister: Amtsgericht Berlin Charlottenburg, HRB 256376 B
        <br />
        E-Mail: <a href="mailto:kontakt@tino247.de">kontakt@tino247.de</a>
        <br />
        Telefon: <a href="tel:+4915792330082">+49 1579 2330082</a>
      </p>

      <h2>2. Art der erhobenen Daten</h2>
      <p>
        Wir verarbeiten ausschließlich Daten, die für die Bereitstellung
        unserer Leistung erforderlich sind:
      </p>
      <ul>
        <li>
          <strong>Stammdaten</strong> der bestellenden Person und der
          Erzählerin / des Erzählers: Name, E-Mail-Adresse, Telefonnummer,
          ggf. Geburtsdatum.
        </li>
        <li>
          <strong>Anrufaufzeichnungen</strong> der Telefongespräche zwischen
          Erzähler/in und unseren KI-Biograf*innen Konrad und Ida.
        </li>
        <li>
          <strong>Transkripte</strong> dieser Gespräche sowie daraus
          abgeleitete biografische Texte.
        </li>
        <li>
          <strong>Server-Logfiles</strong> (IP-Adresse, Datum, Browser-Typ)
          beim Aufruf unserer Website — kurzzeitig zur technischen
          Sicherstellung des Betriebs.
        </li>
      </ul>

      <h2>3. Zweck der Verarbeitung</h2>
      <p>Die Daten werden zu folgenden Zwecken verarbeitet:</p>
      <ul>
        <li>Erstellung der individuellen Lebensbiografie (Buch, Hörbuch).</li>
        <li>Versand des fertigen Buches an die hinterlegte Adresse.</li>
        <li>
          Kommunikation per E-Mail (Bestätigungen, Fortschrittsmitteilungen,
          Rechnungen).
        </li>
        <li>Authentifizierung im persönlichen Bereich auf vitanara.de.</li>
      </ul>

      <h2>4. Rechtsgrundlagen</h2>
      <p>Die Verarbeitung stützt sich auf folgende Rechtsgrundlagen:</p>
      <ul>
        <li>
          <strong>Art. 6 Abs. 1 lit. b DSGVO</strong> — Erfüllung des
          Vertrags über die Erstellung der Biografie.
        </li>
        <li>
          <strong>Art. 6 Abs. 1 lit. a DSGVO</strong> — Einwilligung in die
          Sprachaufzeichnung der Telefongespräche, die zu Beginn jedes
          Anrufs eingeholt wird.
        </li>
        <li>
          <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> — berechtigtes
          Interesse für Server-Logs und IT-Sicherheit.
        </li>
        <li>
          <strong>Art. 6 Abs. 1 lit. c DSGVO</strong> — Erfüllung
          gesetzlicher Aufbewahrungspflichten (z. B. steuerrechtliche).
        </li>
      </ul>

      <h2>5. Eingesetzte Auftragsverarbeiter</h2>
      <p>
        Zur Erbringung unserer Leistung setzen wir sorgfältig ausgewählte
        Auftragsverarbeiter ein. Mit allen wurde ein Vertrag zur
        Auftragsverarbeitung gemäß Art. 28 DSGVO abgeschlossen.
      </p>
      <table>
        <thead>
          <tr>
            <th>Anbieter</th>
            <th>Zweck</th>
            <th>Sitz / Region</th>
            <th>Garantien</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Google Cloud Platform / Firebase</strong>
            </td>
            <td>
              Datenspeicherung (Firestore), Hosting, Authentifizierung, Cloud
              Functions
            </td>
            <td>
              Region <code>europe-west3</code> (Frankfurt am Main)
            </td>
            <td>Google Cloud Data Processing Addendum (DPA)</td>
          </tr>
          <tr>
            <td>
              <strong>Brevo</strong> (vormals Sendinblue)
            </td>
            <td>E-Mail-Versand (SMTP-Relay)</td>
            <td>Paris, Frankreich (EU)</td>
            <td>DPA verfügbar; Verarbeitung innerhalb der EU</td>
          </tr>
          <tr>
            <td>
              <strong>ElevenLabs</strong>
            </td>
            <td>Text-to-Speech, Voice-Cloning für Hörbuch-Produktion</td>
            <td>USA</td>
            <td>EU-US Data Privacy Framework</td>
          </tr>
          <tr>
            <td>
              <strong>Anthropic</strong> (Claude)
            </td>
            <td>KI-Sprachmodell für ergänzende Textverarbeitung</td>
            <td>USA</td>
            <td>EU-Standardvertragsklauseln (SCCs)</td>
          </tr>
          <tr>
            <td>
              <strong>Google AI / Gemini</strong>
            </td>
            <td>
              KI-Sprachmodell für Transkriptanalyse und Strukturierung in
              Kapitel
            </td>
            <td>EU / Frankfurt, soweit verfügbar</td>
            <td>Google Cloud DPA, EU-Datenresidenz</td>
          </tr>
        </tbody>
      </table>

      <h2>6. Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden gespeichert, solange das
        Vertragsverhältnis besteht und solange ein berechtigtes Interesse an
        der Aufbewahrung besteht — etwa für die Auslieferung und Nachpressung
        des Buches. Darüber hinaus gelten gesetzliche Aufbewahrungsfristen,
        in der Regel <strong>10 Jahre</strong> für steuerlich relevante
        Daten (§ 147 AO).
      </p>
      <p>
        Sprachaufzeichnungen werden nach erfolgter Transkription gelöscht,
        sobald keine Qualitätskontrolle mehr erforderlich ist (üblicherweise
        innerhalb von 90 Tagen).
      </p>

      <h2>7. Rechte der betroffenen Personen</h2>
      <p>
        Sie haben jederzeit folgende Rechte uns gegenüber:
      </p>
      <ul>
        <li>Auskunft über gespeicherte Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung („Recht auf Vergessenwerden", Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        <li>
          Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO) — zuständig
          ist beispielsweise die Datenschutzbeauftragte des Sitz-Landes der
          tino24/7 GmbH.
        </li>
      </ul>
      <p>
        Anfragen richten Sie bitte formlos an{" "}
        <a href="mailto:info@vitanara.de">info@vitanara.de</a>.
      </p>

      <h2>8. Cookies und Tracking</h2>
      <p>
        Wir verzichten auf Tracking- und Marketing-Cookies. Die Website
        verwendet ausschließlich technisch notwendige Speicher:
      </p>
      <ul>
        <li>
          <code>sessionStorage</code> für die Zwischenspeicherung des
          Onboardings.
        </li>
        <li>
          Firebase-Authentifizierungs-Cookie für den eingeloggten Bereich.
        </li>
      </ul>

      <h2>9. Übermittlung in Drittländer</h2>
      <p>
        Eine Übermittlung personenbezogener Daten in Länder außerhalb der
        Europäischen Union (insbesondere in die USA) findet im Zusammenhang
        mit ElevenLabs und Anthropic statt. Diese Übermittlungen sind
        abgesichert über das EU-US Data Privacy Framework bzw. über die
        Standardvertragsklauseln (SCCs) der Europäischen Kommission.
      </p>

      <h2>10. Änderungen dieser Erklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn
        sich rechtliche Vorgaben oder unsere Verarbeitungsprozesse ändern.
        Die jeweils aktuelle Fassung ist auf dieser Seite einsehbar.
      </p>
    </LegalLayout>
  );
}
